export default "__VITE_ASSET__975d7ed8__"